import { Button, Text } from '@village/ui';
import { rem } from 'polished';
import styled from 'styled-components';

const Label = styled(Text)`
    display: block;
    margin-bottom: ${rem(6)};
    color: ${({ theme }) => theme.vui.colors.text.grayDefault};
`;

const Container = styled.div`
    .date-picker {
        & #root-portal {
            z-index: 1000 !important;
        }
        button {
            width: ${rem(196)} !important;
        }
        font-family: Apercu, Arial, Helvetica, sans-serif;
    }
`;

const MobileDatePickerButton = styled(Button)`
    min-width: ${rem(196)} !important;
    width: auto;
`;

export { Container, Label, MobileDatePickerButton };
